export default "__VITE_ASSET__CU_Xz3t4__"